import React from "react";

import { DataMapping } from "./Import";
import { DataTable } from "../../types/data/DataTable";
import ImportGridHeader from "./ImportGridHeader";
import ImportGridBody from "./ImportGridBody";

interface ImportGridProps {
    mappings: DataMapping;
    data: DataTable;

    columnChanged: (column: any, value: any) => void;
}

interface ImportGridState {}

class ImportGrid extends React.Component<ImportGridProps, ImportGridState> {
    render(): React.ReactNode {
        return (
            <div className="grid-view fixed-header top-clearance full">
                <div
                    className="display-grid-container"
                    style={{ maxHeight: 400 }}>
                    <table className="table full">
                        <ImportGridHeader
                            columns={this.props.mappings.Target.Columns}
                            columnChanged={this.props.columnChanged}
                        />
                        {/* Data preview rows */}
                        <ImportGridBody data={this.props.data} />
                    </table>
                </div>
            </div>
        );
    }
}

export default ImportGrid;
